export default __webpack_public_path__ + "static/media/pgmico(3).c9c69b2c.png";